export default "__VITE_ASSET__CA3bxwh8__";